import { IconPropTypes } from '@renderer/components/Icons/IconPropTypes'

const HighlightLogoIcon = ({ color = 'currentColor', size = 24, className }: IconPropTypes) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 5.9501C0 4.09994 1.49238 2.6001 3.33333 2.6001C5.17428 2.6001 6.66667 4.09994 6.66667 5.9501V26.0501C6.66667 27.9003 5.17428 29.4001 3.33333 29.4001C1.49238 29.4001 0 27.9003 0 26.0501V5.9501Z"
        fill={color}
      />
      <path
        d="M25.3333 5.9501C25.3333 4.09994 26.8257 2.6001 28.6667 2.6001C30.5076 2.6001 32 4.09994 32 5.9501V26.0501C32 27.9003 30.5076 29.4001 28.6667 29.4001C26.8257 29.4001 25.3333 27.9003 25.3333 26.0501V5.9501Z"
        fill={color}
      />
      <path
        d="M24 16.0001C24 20.4405 20.4183 24.0401 16 24.0401C11.5817 24.0401 8 20.4405 8 16.0001C8 11.5597 11.5817 7.9601 16 7.9601C20.4183 7.9601 24 11.5597 24 16.0001Z"
        fill={color}
      />
    </svg>
  )
}

export default HighlightLogoIcon
